import { render, staticRenderFns } from "./LastCommentCell.vue?vue&type=template&id=1367fd80&scoped=true&"
import script from "./LastCommentCell.vue?vue&type=script&lang=js&"
export * from "./LastCommentCell.vue?vue&type=script&lang=js&"
import style0 from "./LastCommentCell.vue?vue&type=style&index=0&id=1367fd80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1367fd80",
  null
  
)

export default component.exports